module.exports = __webpack_public_path__ + "static/vistajet-4bcd84aed346985343c56c7fd3841d14.png";